/* Shows the discount code Shopify saved for this session. Read-only: it never changes the cart. */
if (!customElements.get('discount-code-notice')) {
  customElements.define('discount-code-notice', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      document.addEventListener('throne:cart-updated', () => this.refresh(), options);
      window.addEventListener('pageshow', event => { if (event.persisted) this.refresh(); }, options);
      this.querySelector('[data-discount-notice-dismiss]').addEventListener('click', () => {
        try { sessionStorage.setItem('throne:discount-notice-dismissed', this.dataset.codes || ''); } catch { /* Storage blocked: hide for this page only. */ }
        this.hidden = true;
      }, options);
      this.refresh();
    }

    async refresh() {
      this.request?.abort();
      const request = this.request = new AbortController();
      let cart;
      try {
        const response = await fetch(this.dataset.cartUrl + '.js', { cache: 'no-store', signal: request.signal });
        if (!response.ok) throw new Error('Cart read failed');
        cart = await response.json();
      } catch {
        return;
      }
      if (request.signal.aborted || !this.isConnected) return;
      // With an empty cart Shopify can't evaluate a code yet, so every saved code counts.
      // Once the cart has items, codes Shopify marks as not applicable drop out.
      const codes = (Array.isArray(cart.discount_codes) ? cart.discount_codes : [])
        .filter(entry => entry && typeof entry.code === 'string' && entry.code.trim()
          && (cart.item_count === 0 || entry.applicable === true))
        .map(entry => entry.code.trim());
      this.dataset.codes = codes.join(',').toLowerCase();
      let dismissed = null;
      try { dismissed = sessionStorage.getItem('throne:discount-notice-dismissed'); } catch { /* No storage. */ }
      // Stay hidden if the compiled stylesheet hasn't arrived (e.g. a stale CDN copy):
      // unstyled, the pill would sit inside the header row and push it out of shape.
      const styled = getComputedStyle(this).position === 'absolute';
      if (!codes.length || dismissed === this.dataset.codes || !styled) {
        this.hidden = true;
        return;
      }
      const text = this.querySelector('[data-discount-notice-text]');
      if (codes.length > 1) {
        text.textContent = this.dataset.multiple;
      } else {
        const [before, after = ''] = this.dataset.single.split('%CODE%');
        const code = document.createElement('strong');
        code.textContent = codes[0];
        text.replaceChildren(before, code, after);
      }
      this.hidden = false;
    }

    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
    }
  });
}
